const meta = {
  metaTags: [
    {
      page_slug: 'category',
    },
    {
      name: "google",
      content: "notranslate",
    },
  ],
};

export default [
  {
    component: () => import('./components/pages/Entry.vue'),
    meta,
    name: 'categories',
    path: '/category',
    children: [
      {
        component: () => import('./components/pages/Categories.vue'),
        meta,
        name: 'categories.index',
        path: '',
      },
      {
        component: () => import('./components/pages/Category.vue'),
        meta,
        name: 'categories.show',
        path: ':category/:subcategory?',
      },
    ],
  },
  {
    component: () => import('./components/pages/NotFound.vue'),
    meta,
    name: 'categories.not-found',
    path: '/category/:pathMatch(.*)*',
  },
];
